
import { StepConnector, stepConnectorClasses } from '@mui/material'
import { styled } from '@mui/material'
import { Color } from '../../utils/theme/types/color';

const QontoConnector = styled(StepConnector)(({ width, colors }: {width?:number; colors:Color}) => ({
    [`&.${stepConnectorClasses.alternativeLabel}`]: {
      left: `-${width}px`,
        right: '0',
        width: `${width}px`,
        top: 13,
        position: 'absolute',
    },
    [`&.${stepConnectorClasses.active}`]: {
      [`& .${stepConnectorClasses.line}`]: {
        borderColor: colors.color4,
      },
    },
    [`&.${stepConnectorClasses.completed}`]: {
      [`& .${stepConnectorClasses.line}`]: {
        borderColor: colors.color4,
      },
    },
    [`& .${stepConnectorClasses.line}`]: {
      borderColor: colors.color10,
      borderTopWidth: 1,
      borderRadius: 1,
    },
  }))
  
  export default QontoConnector